import React, { Component } from 'react';
import { ThumbsUp, MessageCircle, Share2 } from 'lucide-react';
export interface CommentData {
  name: string;
  text: string;
  likes: number;
  timeAgo: string;
  avatarSeed?: string; // Optional seed for avatar generation
}
interface FacebookCommentsProps {
  comments: CommentData[];
}
export function FacebookComments({
  comments
}: FacebookCommentsProps) {
  return <section className="w-full bg-[#f0f2f5] py-12 px-4" data-id="element-37">
      <div className="max-w-2xl mx-auto space-y-4" data-id="element-38">
        <div className="text-center mb-8" data-id="element-39">
          <p className="text-sm font-semibold text-rose-600 uppercase tracking-widest mb-1" data-id="element-40">
            ⭐ Testimonios reales
          </p>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-41">
            Lo que dicen de nosotros en Facebook
          </h3>
        </div>

        {comments.map((comment, index) => <div key={index} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-42">
            <div className="flex gap-3" data-id="element-43">
              {/* Avatar */}
              <div className="flex-shrink-0" data-id="element-44">
                <img src={`https://ui-avatars.com/api/?name=${encodeURIComponent(comment.name)}&background=random&color=fff&size=40`} alt={comment.name} className="w-10 h-10 rounded-full" data-id="element-45" />
              </div>

              {/* Content */}
              <div className="flex-grow" data-id="element-46">
                <div className="bg-gray-100 rounded-2xl px-4 py-2 inline-block" data-id="element-47">
                  <div className="font-bold text-gray-900 text-sm" data-id="element-48">
                    {comment.name}
                  </div>
                  <div className="text-gray-800 text-[15px] leading-snug mt-0.5" data-id="element-49">
                    {comment.text}
                  </div>
                </div>

                {/* Actions Row */}
                <div className="flex items-center gap-4 mt-1 ml-4 text-xs font-semibold text-gray-500" data-id="element-50">
                  <span className="text-sm" data-id="element-51">{comment.timeAgo}</span>
                  <button className="hover:underline cursor-pointer" data-id="element-52">
                    Me gusta
                  </button>
                  <button className="hover:underline cursor-pointer" data-id="element-53">
                    Responder
                  </button>

                  {/* Likes Count Badge */}
                  <div className="flex items-center gap-1 ml-auto bg-white shadow-sm border border-gray-100 rounded-full px-1.5 py-0.5" data-id="element-54">
                    <div className="bg-blue-500 rounded-full p-0.5" data-id="element-55">
                      <ThumbsUp className="w-2 h-2 text-white fill-current" data-id="element-56" />
                    </div>
                    <span className="text-gray-600 font-normal" data-id="element-57">
                      {comment.likes}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>)}

        <div className="text-center pt-4" data-id="element-58">
          <button className="text-gray-600 font-semibold text-sm hover:underline" data-id="element-59">
            Ver más comentarios...
          </button>
        </div>
      </div>
    </section>;
}